import styled from "styled-components";
import { Select } from "discover.medical.react-component-library";

export const StyledSelect = styled(Select)`
  min-width: 5rem;
`;
